import React, {useState, useContext} from 'react';
import {Button, Col, Form, Input, Modal, Row} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {PostUsuari} from "../../../dao/root/PostUsuari";
import {User} from "../../../model/root/User";
import {AuthContext} from "../../../config/AuthContext";

interface IngredientModalProps {
    element: User;
    visible: boolean;
    onClose: (value: boolean) => void;
    page: string;
}

const UsuarisModal: React.FC<IngredientModalProps> = ({element, visible, onClose, page}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user} = useContext(AuthContext);

    async function handleSubmit() {
        const nom = await form.getFieldValue('nom');
        const id = await form.getFieldValue('id');
        const pass = await form.getFieldValue('password');
        await PostUsuari(id, nom, pass, page, userId);
        onClose(true);
    };

    async function handleCancel() {

        onClose(false); 
    };

    return (
        <Modal
            title="Crear/Editar Usuari"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={1000}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={2}>
                        <Form.Item label="id" name="id">
                            <Input type="text" disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="nom" name="nom"
                                   rules={[{ required: true, message: 'Introdueix el nom d\'usuari' }]}>
                            <Input type="text"/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="passwrod" name="password"
                                   rules={[{ required: true, message: 'Introdueix un password' }]}>
                            <Input type="password"/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default UsuarisModal;
